
$(function () {

    function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    zeewishInit();

    $(window).on('loadstatechanged', function (e) {
        zeewishInit();
    });



    let subtotalPrice = 0;
    let hrefShareCode = 'mailto:?Subject=Wishlist&body=Please see my wishlist items below;';

    function zeewishInit() {

        let userWishlist = getCookie("zeewish");
        if (userWishlist != "") {
            let userWishArr = JSON.parse(userWishlist);

            for (var i = 0; i < userWishArr.length; i++) {
                loadProductWishlist(userWishArr[i]);

                $('.like').each(function () {

                    let cookieValues = userWishArr[i].split(",");
                    let productHandle = cookieValues[0];
                    //let productID = cookieValues[1];

                    if ($(this).data("like") == productHandle) {
                        $(this).addClass('is-liked');
                    }
                });
            }


            if (userWishArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.zeeWishCount').removeClass('is-visible');
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();

            } else {
                $('.zeeWishlist-subtotal').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                $('.zeeWishCount').show();
                $('.zeeWishCount').addClass('is-visible');
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }

        } else {
        }
    }

    function addToCookie(value) {
        let userWish = getCookie("zeewish");
        if (userWish != "") {
            let userWishArr = JSON.parse(userWish);

            if (userWishArr.indexOf(value) > -1) {

            } else {
                userWishArr.push(value);
                setCookie("zeewish", JSON.stringify(userWishArr), 90);
            }

            if (userWishArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.zeeWishCount').removeClass('is-visible');
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();

            } else {
                $('.zeeWishlist-subtotal').show();
                $('.your-selection-container').show();
                $('.no-item-text').hide();
                $('.zeeWishCount').show();
                $('.zeeWishCount').addClass('is-visible');
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }

        } else {
            let userWishArr = [value];
            setCookie("zeewish", JSON.stringify(userWishArr), 90);

            if (userWishArr.length == 0) {
                $('.zeeWishlist-subtotal').hide();
                $('.zeeWishCount').hide();
                $('.zeeWishCount').removeClass('is-visible');
                $('.no-item-text').show();
                $('.your-selection-container').hide();
            } else {
                $('.zeeWishlist-subtotal').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                $('.zeeWishCount').show();
                $('.zeeWishCount').addClass('is-visible');
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }
        }
    }

    function removeFromCookie(value) {
        let userWish = getCookie("zeewish");
        if (userWish != "") {

            let userWishArr = JSON.parse(userWish);

            if (userWishArr.indexOf(value) > -1) {
                let index = userWishArr.indexOf(value);
                if (index > -1) {
                    userWishArr.splice(index, 1);
                }
            }
            setCookie("zeewish", JSON.stringify(userWishArr), 90);

            if (userWishArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.zeeWishCount').removeClass('is-visible');
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();

            } else {
                $('.zeeWishlist-subtotal').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                $('.zeeWishCount').show();
                $('.zeeWishCount').addClass('is-visible');
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }

        } else {


        }
    }


    function loadProductWishlist(cookieValue) {

        let cookieValues = cookieValue.split(",");
        let productHandle = cookieValues[0];
        let productID = cookieValues[1];



        let loadcssSelector = ".zeeWishlist-table [data-liked='" + productHandle + "']";
        if (!$(loadcssSelector).length) {
            let apiURL = "/products/" + productHandle + ".js";
            jQuery.getJSON(apiURL, function (product) {
                let wheelSize = 0;
                for (let i = 0; i < product.tags.length; i++) {
                    for (x = 16; x <= 24; x++) {
                        let xStr = x + '"';
                        if (product.tags[i] == xStr) {
                            wheelSize = xStr;
                            break;
                        }
                    }
                }
                let productHTML = '';
                let productPriceHTML = '';

                if (product.type == "Wheel" || product.type == "wheel" || product.type == "wheels" || product.type == "Wheels") {
                    var wheelMultiplier = (product.tags && product.tags.indexOf('wheel-fixed-set-of-4') !== -1) ? 1 : 4;
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * wheelMultiplier + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p></a></div>';

                    if (product.available) {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * wheelMultiplier + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * wheelMultiplier, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><a class="zeeWishlist-a2c ajax_add_to_cart" data-pid="' + productID + '" data-pqty="' + wheelMultiplier + '">ADD TO CART</a></div>';
                    } else {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * wheelMultiplier + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * wheelMultiplier, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><a class="zeeWishlist-a2c" data-pid="' + productID + '" data-pqty="' + wheelMultiplier + '">OUT OF STOCK</a></div>';
                    }
                    subtotalPrice += product.price * 1.2 * wheelMultiplier;
                } else {
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p></a></div>';
                    if (product.available) {

                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><a class="zeeWishlist-a2c ajax_add_to_cart" data-pid="' + productID + '" data-pqty="' + 1 + '">ADD TO CART</a></div>';
                    } else {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><a class="zeeWishlist-a2c" data-pid="' + productID + '" data-pqty="' + 1 + '">OUT OF STOCK</a></div>';
                    }
                    subtotalPrice += product.price * 1.2;
                }

                $('.wishlist-widget-side .zeeWishlist-table').append(productHTML);
                $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));

                if ($('.zeewishlist-page').length) {
                    $('.zeewishlist-page .zeeWishlist-table').append(productPriceHTML);
                    hrefShareCode += '%0D%0A ' + (product.title.length > 50 ? product.title.substring(0, 50) + '...' : product.title) + ' - https://chelseatruckcompany.com' + product.url + ' %0D%0A  ';
                    $('.js-wishlist-email-share').attr("href", hrefShareCode);

                }

            });
        }
    }

    function removeFromProductWishlist(cookieValue) {

        let cookieValues = cookieValue.split(",");
        let productHandle = cookieValues[0];
        let productID = cookieValues[1];

        let itemcssSelector = "[data-like='" + productHandle + "']";
        if ($(itemcssSelector)) {
            $(itemcssSelector).removeClass('is-liked');

        }

        let removecssPriceSelector = ".wishlist-widget-side.zeeWishlist-table [data-liked='" + productHandle + "']";
        if ($(removecssPriceSelector).length) {
            subtotalPrice -= $(removecssPriceSelector).data('liked-price');
            $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));
        }

        let removecssSelector = ".zeeWishlist-table [data-liked='" + productHandle + "']";
        $(removecssSelector).fadeOut(300, function () {
            $(this).remove();
            removeFromCookie(cookieValue);
        });

    }

    $('body').on('click', '.like', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-liked');
        let productHandle = $(this).data('like');
        let productVID = $(this).data('like-id');
        let cookieValue = productHandle + ',' + productVID;
        if ($(this).hasClass('is-liked')) {
            addToCookie(cookieValue);
            loadProductWishlist(cookieValue);

        } else {
            removeFromCookie(cookieValue);
            removeFromProductWishlist(cookieValue);
        }
    });

    $('.zeeWishlist-table').on('click', '.zeeWishlist-cross', function () {
        let removeValue = $(this).parent().data('liked') + ',' + $(this).parent().data('pid');
        removeFromProductWishlist(removeValue);
    });

    $('body').on('click', '.js-add-all-to-cart', function (e) {
        e.preventDefault();
        let addToCartButtons = $('.zeewishlist-page .zeeWishlist-table .ajax_add_to_cart');
        let buttonCount = addToCartButtons.length;

        if (buttonCount > 0) {
            // Add a small delay between each add to cart to avoid overwhelming the server
            addToCartButtons.each(function(index) {
                let button = $(this);
                setTimeout(function() {
                    button.trigger('click');
                }, index * 500); // 500ms delay between each add
            });
        }
    });


});
